module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat1-a1bee7bd324c559bb13a39fc7bdfb6e8.svg";